import { createContext, useContext } from 'react';
import { cn } from '@bridebook/aura';
import { cva } from 'class-variance-authority';

interface FieldContextValue {
  error?: boolean;
  disabled?: boolean;
}

const FieldContext = createContext<FieldContextValue | undefined>(undefined);

export const useFieldContext = () => {
  const context = useContext(FieldContext);
  return context;
};

export interface FieldProps extends React.ComponentPropsWithoutRef<'div'> {
  error?: boolean;
  disabled?: boolean;
}

const fieldVariants = cva('flex flex-col gap-2', {
  variants: {
    disabled: {
      true: 'opacity-40',
      false: '',
    },
  },
});

export const Field = ({ className, error, disabled, children, ...props }: FieldProps) => (
  <FieldContext.Provider value={{ error, disabled }}>
    <div className={cn(fieldVariants({ disabled }), className)} {...props}>
      {children}
    </div>
  </FieldContext.Provider>
);

Field.displayName = 'Field';
